import { z } from 'zod/v4-mini'

export const searchParamsSearchTextSchema = z.object({
    searchText: z._default(z.string(), ''),
})

export const searchParamsSearchTextDefaultValues: z.infer<
    typeof searchParamsSearchTextSchema
> = {
    searchText: searchParamsSearchTextSchema.shape.searchText.def.defaultValue,
}
